import React, { useState } from 'react';
import Tab from '@mui/material/Tab';
import { StickyTab, TabContainer } from 'components/Ui/styled';
import TabPanel, { a11yProps } from 'components/Common/TabPanel/TabPanel';
import BookedSessions from './components/bookedSessionsTab/BookedSessionsTab';
import SubjectsAndTutorsTab from './components/subjectsAndTutorsTab/SubjectsAndTutorsTab';
import ManageTimeBlocksTab from './components/manageTimeBlocksTab/ManageTimeBlocksTab';
import NewSessionTab from './components/newSessionTab/NewSessionTab';

const TutoringTab = () => {
  const [value, setValue] = useState(0);

  const handleTabChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <TabContainer>
      <StickyTab
        value={value}
        onChange={handleTabChange}
        aria-label="tutoringTab"
      >
        <Tab label="Subjects & Tutors" {...a11yProps(0)} />
        <Tab label="Manage Time Blocks" {...a11yProps(1)} />
        <Tab label="Booked Sessions" {...a11yProps(2)} />
        <Tab label="New Session" {...a11yProps(3)} />
      </StickyTab>
      <TabPanel value={value} index={0}>
        <SubjectsAndTutorsTab />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <ManageTimeBlocksTab />
      </TabPanel>
      <TabPanel value={value} index={2}>
        <BookedSessions />
      </TabPanel>
      <TabPanel value={value} index={3}>
        <NewSessionTab />
      </TabPanel>
    </TabContainer>
  );
};

export default TutoringTab;
